// extracted by mini-css-extract-plugin
module.exports = {"quizBlock":"styles_quizBlock__3NkON","quizContainer":"styles_quizContainer__3VtiC","fluid":"styles_fluid__1PogH"};